import { Filter } from '@iot-platform/models/common';
import { I4BGridFilterOptions } from '@iot-platform/models/grid-engine';
import { MultiSelectBatchFilter } from '../models';

export function isMultiSelectBatchFilter(filter: any): filter is MultiSelectBatchFilter {
  return filter.isMultiSelectBatch === true && !!filter.fieldKey;
}

export function hasBlankOrNotBlankFilter(filter: Filter): boolean {
  return filter.criteriaOperator === I4BGridFilterOptions.BLANK || filter.criteriaOperator === I4BGridFilterOptions.NOT_BLANK;
}

export function processMultiSelectBatch(batchFilter: MultiSelectBatchFilter, currentFilters: Filter[]): Filter[] {
  const { fieldKey, clearAllForField, values, criteriaKey, criteriaLabel, criteriaOperator } = batchFilter;

  // Keep filters that don't match this field, OR have BLANK/NOT_BLANK operators (preserve blank filters)
  const filtersWithoutThisField = currentFilters.filter((f) => f.criteriaKey !== fieldKey);

  if (clearAllForField) {
    return filtersWithoutThisField;
  }

  if (hasBlankOrNotBlankFilter(batchFilter)) {
    return [
      ...filtersWithoutThisField,
      {
        criteriaKey,
        criteriaLabel,
        criteriaOperator,
        value: null,
        label: criteriaOperator,
        valueDisplay: criteriaOperator
      }
    ];
  }

  if (!values || !Array.isArray(values) || values.length === 0) {
    return filtersWithoutThisField;
  }

  const newFilters = values.map((item) => ({
    criteriaKey,
    criteriaLabel,
    criteriaOperator,
    value: item.value,
    valueDisplay: item.valueDisplay,
    label: item.valueDisplay
  }));

  return [...filtersWithoutThisField, ...newFilters];
}
